export const getCollections = (tenantId: string) => ({
  USERS: `tenants/${tenantId}/users`,
  CLUBS: `tenants/${tenantId}/clubs`,
  TEAMS: `tenants/${tenantId}/teams`,
  COMPETITIONS: `tenants/${tenantId}/competitions`,
  SEASONS: `tenants/${tenantId}/seasons`,
  SANCTIONS: `tenants/${tenantId}/sanctions`,
  MATCHES: `tenants/${tenantId}/matches`,
  MOVEMENTS: `tenants/${tenantId}/movements`,
  REQUESTS: `tenants/${tenantId}/requests`,
  TRANSFERS: `tenants/${tenantId}/transfers`,
  INVOICES: `tenants/${tenantId}/invoices`,
  RECEIPTS: `tenants/${tenantId}/receipts`,
  NOTIFICATIONS: `tenants/${tenantId}/notifications`,
  EMAILS: `tenants/${tenantId}/emails`,
  JOURNEYS: `tenants/${tenantId}/journeys`,
  LICENSE_RATES: `tenants/${tenantId}/license_rates`,
  SEASON_RATES: `tenants/${tenantId}/season_rates`,
  MASTERS: `tenants/${tenantId}/masters`,
  SPONSORS: `tenants/${tenantId}/sponsors`,
  MEMBERSHIP_FEES: `tenants/${tenantId}/membership_fees`,
  MEMBERS: `tenants/${tenantId}/members`,
  UNSUBSCRIBES: `tenants/${tenantId}/unsubscribes`,
  SUGGESTED_USERS: `tenants/${tenantId}/suggested_users`,
  ACCOUNTING: `tenants/${tenantId}/accounting`,
  ACCOUNTING_COST_CENTERS: `tenants/${tenantId}/accounting_cost_centers`,
  ACCOUNTING_GRANTS: `tenants/${tenantId}/accounting_grants`,
  ACCOUNTING_BUDGET: `tenants/${tenantId}/accounting_budget`,
  CONTACTS: `tenants/${tenantId}/contacts`,
  MANUAL_INVOICES: `tenants/${tenantId}/manual_invoices`,
  AVAILABILITY_POLLS: `tenants/${tenantId}/availability_polls`,
  CALL_UPS: `tenants/${tenantId}/call_ups`,
  FACILITY_ZONES: `tenants/${tenantId}/facility_zones`,
  SPORT_FACILITIES: `tenants/${tenantId}/sport_facilities`,
  FACILITY_RESERVATIONS: `tenants/${tenantId}/facility_reservations`,
  FACILITY_SLOTS: `tenants/${tenantId}/facility_slots`,
  SESSION_BONOS: `tenants/${tenantId}/session_bonos`,
  MEMBER_BONOS: `tenants/${tenantId}/member_bonos`,
  // ─── Tecnificación ──────────────────────────────────────────────────────
  TECHNIFICATION_PROGRAMS: `tenants/${tenantId}/technification_programs`,
  TECHNIFICATION_ENROLLMENTS: `tenants/${tenantId}/technification_enrollments`,
  TECHNIFICATION_WELLNESS: `tenants/${tenantId}/technification_wellness`,
  // Subcolecciones del programa (construcción dinámica)
  technificationSessions: (programId: string) =>
    `tenants/${tenantId}/technification_programs/${programId}/sessions`,
  technificationEvaluations: (programId: string) =>
    `tenants/${tenantId}/technification_programs/${programId}/evaluations`,
  technificationGoals: (programId: string) =>
    `tenants/${tenantId}/technification_programs/${programId}/goals`,
  // ─── Wearables ──────────────────────────────────────────────────────────
  WEARABLE_CONNECTIONS: `tenants/${tenantId}/wearable_connections`,
  WEARABLE_DAILY_METRICS: `tenants/${tenantId}/wearable_daily_metrics`,
  WEARABLE_ACTIVITIES: `tenants/${tenantId}/wearable_activities`,
  // ─── Noticias ────────────────────────────────────────────────────────────
  NEWS: `tenants/${tenantId}/news`,
});

export const PLATFORM_COLLECTIONS = {
  TENANTS: 'tenants',
  SUPPORT_PACKAGES: 'platform/support_packages',
  SUPPORT_ORDERS: 'platform/support_orders',
  SUPPORT_ENTRIES: 'platform/support_entries',
  TENANT_INVITATIONS: 'tenant_invitations',
};
